module.exports = __webpack_public_path__ + "static/media/party.6b5ac9b8.jpg";